"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardLayout = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../helpers");
const zIndexManager_1 = require("../helpers/zIndexManager");
const PageWizardMain_1 = require("./components/PageWizardMain/PageWizardMain");
const PageWizardPanelContainerProvider_1 = require("./context/providers/PageWizardPanelContainerProvider");
const PageWizardPanelProvider_1 = require("./context/providers/PageWizardPanelProvider");
const StackView_1 = require("../StackView");
const View_1 = require("../View");
exports.PageWizardLayout = (0, helpers_1.createUIElement)('PageWizardLayout', (_a, ref) => {
    var { className, header, tabs, content, footer, loading, panel, panelMinWidth, panelWidth, shrinkPanel, pending, fullWidthContent, widthContent, hideTabs, onRequestClose, onKeyPress, style } = _a, rest = __rest(_a, ["className", "header", "tabs", "content", "footer", "loading", "panel", "panelMinWidth", "panelWidth", "shrinkPanel", "pending", "fullWidthContent", "widthContent", "hideTabs", "onRequestClose", "onKeyPress", "style"]);
    (0, zIndexManager_1.useZIndexManager)({
        onKeyPress: (e) => {
            if (e.keyCode === helpers_1.KeyCode.Escape) {
                onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
            }
            onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(e);
        }
    });
    return (react_1.default.createElement(PageWizardPanelContainerProvider_1.PageWizardPanelContainerProvider, null,
        react_1.default.createElement(PageWizardPanelProvider_1.PageWizardPanelProvider, null,
            react_1.default.createElement(StackView_1.StackView, Object.assign({}, rest, { testId: rest['data-selector-id'] || 'pagewizard-layout', className: (0, helpers_1.cn)('vm-PageWizardLayout', className), tabIndex: -1, direction: StackView_1.STACK_DIRECTION.column, spaceFill: View_1.SPACE_FILL.all, backgroundView: View_1.VIEW_BG_VIEW.normal, ref: ref, style: style }),
                header,
                react_1.default.createElement(PageWizardMain_1.PageWizardMain, { tabs: tabs, content: content, footer: footer, loading: loading, panel: panel, panelMinWidth: panelMinWidth, panelWidth: panelWidth, shrinkPanel: shrinkPanel, pending: pending, fullWidthContent: fullWidthContent, widthContent: widthContent, hideTabs: hideTabs })))));
});
//# sourceMappingURL=PageWizardLayout.js.map